const AI_ERROR_CODES = {
    "feedback.ai_summary_failed": "Organizational.Messages.AiSummary.Error",
    "feedback.ai_not_configured": "Organizational.Messages.AiSummary.NotConfigured",
    "company_required": "Organizational.Messages.AiSummary.CompanyRequired",
};

const AI_ERROR_DETAILS = {
    "AI service could not generate the messages summary.":
        "Organizational.Messages.AiSummary.Error",
    "AI service is not configured.":
        "Organizational.Messages.AiSummary.NotConfigured",
    "A company user is required.":
        "Organizational.Messages.AiSummary.CompanyRequired",
};

function firstDetail(detail) {
    if (Array.isArray(detail)) return detail[0];
    return detail;
}

export function messageFromAiError(error, t, fallbackKey) {
    const data = error?.response?.data || {};
    if (data.code && AI_ERROR_CODES[data.code]) {
        return t(AI_ERROR_CODES[data.code]);
    }
    const detail = firstDetail(data.detail);
    if (typeof detail === "string" && AI_ERROR_DETAILS[detail]) {
        return t(AI_ERROR_DETAILS[detail]);
    }
    if (typeof detail === "string" && /[آ-ی]/.test(detail)) {
        return detail;
    }
    return t(fallbackKey);
}
